export function getSiteName(){
   return '<span style="font-weight:400 !important;" class="notranslate">my</span><span style="font-weight: bold;" class="notranslate">member.</span><span style="font-weight: 400 !important;" class="notranslate">site</span>';
   // return 'mymember.site';
   // return 'adultmembersites.com';
}
export function getCapitalizeSiteName(){
   return '<span style="font-weight:400 !important;" class="notranslate">my</span><span style="font-weight: bold;" class="notranslate">member.</span><span style="font-weight: 400 !important;" class="notranslate">site</span>';
   // return 'mymember.site';
   // return 'AdultMemberSites.com';
}
export function getSiteLink(){
   return 'https://mymember.site/';
   // return 'https://adultmembersites.com/';
}
export function getSiteTitle(){
   return '<span style="font-weight:400 !important;" class="notranslate">my</span><span style="font-weight: bold;" class="notranslate">member.</span><span style="font-weight: 400 !important;" class="notranslate">site</span>';
   // return 'mymember.site';
   // return 'AdultMemberSites';
}
export function getSiteNameAbbreviatur(){
   return 'MMS';
   // return 'AMS';
}
export function getSiteMediainName(){
   return 'MMSMEDIAIN';
   // return 'AMSMEDIAIN';
}
export function getSupportEmail(){
   return 'support@mymember.site';
}
export function getNoRepliesEmail(){
   return 'no-reply@mymember.site';
}
export function getLegalEmail(){
   return 'legal@mymember.site';
}
export function getNickName(){
   return '@mymember_site';
}
export function getSupportEmailText(){
   return 'support@my<span style="font-weight: bold;">member.</span>site';
}

export function isLocalhost(){
   return Boolean(
      window.location.hostname === 'localhost'
        // [::1] is the IPv6 localhost address.
        || window.location.hostname === '[::1]'
        // 127.0.0.1/8 is considered localhost for IPv4.
        || window.location.hostname.match(
           /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
        )
        || window.location.hostname.match(
           /^192(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
        )
   );
}

export const getSiteNameHtml = (name = 'member') => {
   return `my<span style="font-weight: bold;">${ name }.</span>site`;
}

export const getAffiliateDisplayHtml = () => {
   return `my.site<span style="font-weight: bold;">affiliate</span>`
}

export const replacePartOfText = (text, searchValue, replaceValue) => {
   return text.replaceAll(searchValue, replaceValue)
}

export const abbreviateNumber = (value) => {
   const isMinus = value < 0
   let newValue = Math.abs(value);
   const suffixes = ["", "K", "M", "B", "T"];
   let suffixNum = 0;
   while(newValue >= 1000) {
      newValue /= 1000;
      suffixNum++;
   }
   let valueString =
       newValue.toString().length > 2
          ? newValue.toPrecision(3)
          : newValue.toPrecision();

   valueString += suffixes[suffixNum];

   const lastIndexNull = valueString.lastIndexOf('0')
   if(lastIndexNull !== 0 && lastIndexNull !== -1) {
      if(valueString[lastIndexNull + 1] && valueString.includes('.') && suffixes.includes(valueString[lastIndexNull + 1])) {
         valueString = valueString.slice(0, lastIndexNull) + valueString.slice(lastIndexNull + 1)
      }
   }
   return isMinus ? `-${ valueString }` : valueString;
}

export const getItalicXHtml = () => {
   return `<span style="font-style: italic;">X</span>`;
}
